module.exports = __webpack_public_path__ + "img/landing-page-background.781c0ab9.webp";